<div class="bg-card w-full p-5">
  <div class="xs:block xs:text-center flex justify-between gap-2">
    <h1>
      {{ 'sidebar:verifiedProviders' | translate }}
    </h1>

    <div class="flex gap-2">
      <!-- help -->
      <ew-button-help url="https://help.edvisor.io/edwallet/payouts"></ew-button-help>

      <ew-provider-header-actions></ew-provider-header-actions>
    </div>
  </div>

  <ew-table class="xs:hidden w-full" matSort [loading]="loading" [data]="tableDataProviders" [columns]="columns"
    [empty]="{
      title:   ('shared:emptyTableMessage' | translate).replace(
      ':transactionName',
      'shared:providers' | translate
    ),
}">
    <!-- alias -->
    <ng-container matColumnDef="alias">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'createBankAccount:inputAlias' | translate }}
      </th>
      <td mat-cell *matCellDef="let row" class="align-center text-light">
        {{ row.alias }}
      </td>
    </ng-container>

    <!-- bank name -->
    <ng-container matColumnDef="bankName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'bankAccounts:bank' | translate }}
      </th>
      <td mat-cell *matCellDef="let row" class="align-center text-light">
        {{ row.bankAccount.bankName }}
      </td>
    </ng-container>

    <!-- account number -->
    <ng-container matColumnDef="accountNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'createBankAccount:beneficiary' | translate }}
      </th>
      <td mat-cell *matCellDef="let row" class="align-center text-light">
        {{ row.bankAccount.payee_name }}<br>
        {{ row.bankAccount.accountNumber | maskAccountNumber }}
      </td>
    </ng-container>

    <!-- country -->
    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'settingsBankAccounts:column3' | translate }}
      </th>
      <td mat-cell *matCellDef="let row" class="align-center text-light">
        <ew-table-card-item class="xs:max-w-[87%]" [img]="
            'https://flagcdn.com/' +
            (row.bankAccount.currency | currencyCountry) +
            '.svg'
          " [title]="row.bankAccount.currency" [subtitle]="
            'currencyName:' + row.bankAccount.currency | translate
          "></ew-table-card-item>
      </td>
    </ng-container>

    <!-- status -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'transactions:columnStatus' | translate }}
      </th>
      <td mat-cell *matCellDef="let row" class="text-light">
        <span class="badge badge-neutral" [class.badge-success]="row.bankAccount.status == 'verified'"
          [class.badge-warning]="row.bankAccount.status == 'unverified'" [class.badge-critical]="
            row.bankAccount.status == 'denied' ||
            row.bankAccount.status == 'canceled'
          ">
          {{
          'bankAccounts:status' + row.bankAccount.status.toUpperCase()
          | translate
          }}
        </span>
      </td>
    </ng-container>

    <!-- Acciones -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="text-right w-10"></th>
      <td mat-cell *matCellDef="let row" class="text-right">
        <button mat-icon-button [matMenuTriggerFor]="actionsMenu" [matMenuTriggerData]="{ bankAccount: row }">
          <i class="fa-regular fa-ellipsis-vertical"></i>
        </button>
      </td>
    </ng-container>
  </ew-table>

  <mat-menu #actionsMenu="matMenu">
    <ng-template matMenuContent let-row="bankAccount" let-bankAccountId="bankAccount.bankAccountId"
      let-alias="bankAccount.alias">
      <button mat-menu-item (click)="bankAccount = row; open = true">
        <i class="fa-regular fa-eye"></i>
        <span>{{ 'transactions:buttonOpenDetails' | translate }}</span>
      </button>
      <button mat-menu-item (click)="editBankAccount(row)" [disabled]="row.bankAccount.status !== 'verified'"
        [matTooltip]="row.bankAccount.status !== 'verified' ? ('bankAccounts:onlyVerifiedEditable' | translate) : ''">
        <i class="fa-regular fa-pen-to-square"></i>
        <span>{{ 'shared:edit' | translate }}</span>
      </button>
      <button mat-menu-item (click)="deleteBeneficiaryAccount(row.bank_account_id, row.alias)">
        <i class="fa-regular fa-ban"></i>
        <span>{{ 'deleteProvider:buttonText' | translate }}</span>
      </button>
    </ng-template>
  </mat-menu>

  <!-- view mobile -->
  <div class="xs:block hidden">
    <div class="mt-2" *ngFor="let row of tableDataProviders?.records">
      <ew-table-card (click)="open = true">
        <ew-table-card-row>
          <ew-table-card-column>
            {{ row.alias }}
          </ew-table-card-column>
          <ew-table-card-column>
            <span class="badge badge-neutral" [class.badge-success]="row.bankAccount?.status == 'verified'"
              [class.badge-warning]="row.bankAccount?.status == 'unverified'" [class.badge-critical]="
                row.bankAccount?.status == 'denied' ||
                row.bankAccount?.status == 'canceled'
              ">
              {{
              'bankAccounts:status' + row.bankAccount?.status?.toUpperCase()
              | translate
              }}
            </span>
          </ew-table-card-column>
        </ew-table-card-row>

        <ew-table-card-row>
          <ew-table-card-column>
            <div class="">
              <i class="fa-regular fa-calendar mr-2"></i>
              {{ row.createdAt | date : 'mediumDate' }}
            </div>
          </ew-table-card-column>
        </ew-table-card-row>
      </ew-table-card>
    </div>
  </div>

  <ew-sidebar [open]="open" [title]="
      bankAccount
        ? ('createBankAccount:detailsTitle' | translate)
        : ('createBankAccount:createTitle' | translate)
    " (close)="open = false">
    <div class="mt-5" *ngIf="open && bankAccount">
      <div class="mb-8">
        <h3 class="mb-2">{{ 'createBankAccount:inputAlias' | translate }}</h3>
        <p>{{ bankAccount.alias }}</p>
      </div>
      <div class="mb-8">
        <h3 class="mb-2">
          {{ 'createBankAccount:inputBankName' | translate }}
        </h3>
        <p>{{ bankAccount.bankAccount?.bankName }}</p>
      </div>
      <div class="mb-8">
        <h3 class="mb-2">{{ 'createBankAccount:inputSwift' | translate }}</h3>
        <p>{{ bankAccount.bankAccount?.swift }}</p>
      </div>
      <div class="mb-8" *ngIf="bankAccount.bankAccount?.accountNumber">
        <h3 class="mb-2">
          {{
          ((bankAccount.bankAccount?.routingCode?.length || 0) > 0
          ? 'createBankAccount:inputAccountNumber'
          : 'createBankAccount:inputIban'
          ) | translate
          }}
        </h3>
        <p>{{ bankAccount.bankAccount?.accountNumber }}</p>
      </div>
      <div class="mb-8" *ngIf="(bankAccount.bankAccount?.routingCode?.length || 0) > 0">
        <h3 class="mb-2">
          {{
          ((bankAccount.bankAccount?.routingCode?.length || 0) === 6
          ? 'createBankAccount:inputRoutingCodeBsb'
          : 'createBankAccount:inputRoutingCodeAba'
          ) | translate
          }}
        </h3>
        <p>{{ bankAccount.bankAccount?.routingCode }}</p>
      </div>
      <div class="mb-8">
        <h3 class="mb-2">{{ 'createBankAccount:inputCountry' | translate }}</h3>
        <p>{{ bankAccount.bankAccount?.country | uppercase }}</p>
      </div>
      <div class="mb-8">
        <h3 class="mb-2">
          {{ 'createBankAccount:inputCurrency' | translate }}
        </h3>
        <p>{{ bankAccount.bankAccount?.currency | uppercase }}</p>
      </div>
      <div class="mb-8">
        <h3 class="mb-2">{{ 'createBankAccount:status' | translate }}</h3>
        <span class="badge {{
            bankAccount.bankAccount?.status == 'verified'
              ? 'badge-success'
              : 'badge-accent'
          }}">{{ bankAccount.bankAccount?.status }}</span>
      </div>
    </div>
  </ew-sidebar>

  <mat-menu #menu="matMenu">
    <ng-template matMenuContent let-row="provider">
      <a mat-menu-item (click)="sendPayment(row)" *ngIf="row.status == 'verified'">
        <i class="fa-regular fa-building-columns"></i>
        <span>{{ 'verifiedProviders:sendPayment' | translate }}</span>
      </a>
      <a mat-menu-item (click)="bankAccount = row; open = true">
        <i class="fa-regular fa-eye"></i>
        <span>{{ 'transactions:buttonOpenDetails' | translate }}</span>
      </a>
      <a mat-menu-item (click)="editBankAccount(row)" [disabled]="row.bankAccount.status !== 'verified'">
        <i class="fa-regular fa-pen-to-square"></i>
        <span>{{ 'shared:edit' | translate }}</span>
      </a>
      <a mat-menu-item (click)="deleteBeneficiaryAccount(row.bank_account_id, row.alias)"
        *ngIf="row.type == 'custom_provider'">
        <i class="fa-regular fa-ban"></i>
        <span>{{ 'deleteProvider:buttonText' | translate }}</span>
      </a>
    </ng-template>
  </mat-menu>
</div>